// extracted by mini-css-extract-plugin
export default {"wrapper":"side-section-border-chunk_wrapper__MOBcc","diagonal":"side-section-border-chunk_diagonal__8P-qC"};